<template>
  <div>
    <el-dialog
      :title="
        rechargeType == 1 ? $t('lang.代客充值') : $t('lang.充值成功回执单')
      "
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :append-to-body="true"
      :width="rechargeType == 1 ? '569px' : '489px'"
    >
      <el-form
        v-if="rechargeType == 1"
        :style="{ paddingLeft: $i18n.locale == 'zh-CN' ? '0px' : '30px' }"
      >
        <el-form-item :label="$t('lang.设备名称')">
          <el-input disabled v-model="deviceForm.deviceName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.租客名称')">
          <el-input disabled v-model="deviceForm.nickName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.剩余水量')">
          <el-input disabled v-model="deviceForm.remainKwh">
            <span slot="suffix">m³</span>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.水价')">
          <el-input disabled v-model="deviceForm.priceValue">
            <span slot="suffix">{{ monetary + "/m³" }}</span>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.充值方式')">
          <el-select v-model="rechargeValue" @change="rechargeChange">
            <el-option
              v-for="item in rechargeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.充值水量')">
          <el-input :disabled="!rechargeValue" type="number" v-model="rechargePower" @input="limitOneDecimal">
            <span slot="suffix">m³</span>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.充值金额')">
          <el-input :disabled="rechargeValue" v-model="rechargeAmount" @input="limitTwoDecimal">
            <span slot="suffix">{{ monetary }}</span>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.二级密码')" v-if="isPwd">
          <el-input v-model="password" :placeholder="$t('lang.请输入二级密码')"></el-input>
        </el-form-item>
      </el-form>
      <div v-else>
        <div class="space-occupying">
          <img
            class="printingPaper"
            src="@/assets/img/device_list/receipt.png"
            alt=""
          />
          <div class="returnReceiptCon">
            <h2>{{ $t("lang.充值回执单") }}</h2>
            <div class="dividingLine"></div>
            <div
              :class="['content', $i18n.locale == 'zh-CN' ? '' : 'en_content']"
            >
              <div class="con_title">
                <div class="multipleLin">
                  <span>{{ $t("lang.订单编号") }}</span
                  ><span v-if="$i18n.locale == 'zh-CN'">:</span>
                </div>
                <div>
                  <span>{{ $t("lang.客户名称") }}</span
                  ><span v-if="$i18n.locale == 'zh-CN'">:</span>
                </div>
                <div>
                  <span>{{ $t("lang.联系电话") }}</span
                  ><span v-if="$i18n.locale == 'zh-CN'">:</span>
                </div>
                <div>
                  <span>{{ $t("lang.资产号") }}</span
                  ><span v-if="$i18n.locale == 'zh-CN'">:</span>
                </div>
                <div>
                  <span>{{ $t("lang.充值水量") }}</span
                  ><span v-if="$i18n.locale == 'zh-CN'">:</span>
                </div>
                <div class="multipleLin">
                  <span>{{ $t("lang.充值Token") }}</span
                  ><span v-if="$i18n.locale == 'zh-CN'">:</span>
                </div>
                <div>
                  <span>{{ $t("lang.支付时间") }}</span
                  ><span v-if="$i18n.locale == 'zh-CN'">:</span>
                </div>
              </div>
              <div class="con_text">
                <div class="multipleLin">{{ receiptData.orderNo }}</div>
                <div>{{ deviceForm.deviceName }}</div>
                <div>{{ deviceForm.phone }}</div>
                <div>{{ receiptData.tagNo }}</div>
                <div>{{ fix(rechargePower) }}m³</div>
                <div class="multipleLin">
                  {{ receiptData.token
                  }}<i class="el-icon-copy-document" @click="onClickCopy"></i>
                </div>
                <div>{{ receiptData.createTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div v-if="rechargeType == 1">
          <el-button @click="dialogVisible = false">
            {{ $t("lang.取消") }}
          </el-button>
          <el-button
            type="primary"
            @click="onClickConfirmRecharge"
            :loading="loading"
            >{{ $t("lang.确认充值") }}</el-button
          >
        </div>
        <div v-else>
          <el-button type="primary" @click="onClickPrint">{{
            $t("lang.打印")
          }}</el-button>
          <el-button  @click="dialogVisible = false">{{
            $t("lang.我知道了")
          }}</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import mixinf from "@/app/common/mixin/mixin-global.js";
export default {
  mixins: [mixinf],
  data() {
    return {
      dialogVisible: false,
      rechargeType: 1,
      deviceForm: {
        deviceName: "",
        nickName: "",
        remainKwh: "",
        priceValue: "",
      },
      rechargeOptions:[
        {
          label:this.$t("lang.水量"),
          value:true,
        },
        {
          label:this.$t("lang.金额"),
          value:false,
        },
      ],
      rechargeValue:true,
      rechargePower: "",
      rechargeAmount: 0,
      receiptData: {},
      loading: false,
      monetary: "元",
      password: "",
      isPwd: false,
    };
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.isPwd = this.$store.getters["password/openFactorAuthent2"];
      }
    },
    rechargePower(val) {
      if (this.rechargeValue && this.rechargeType ===  1){
        this.rechargeAmount = this.ceilToFixed((val * this.deviceForm.priceValue),2);
      }
    },
    rechargeAmount(val) {
      if (!this.rechargeValue && this.rechargeType ===  1){
        this.rechargePower = this.floorToFixed((val / this.deviceForm.priceValue),1);
      }
    },
  },
  methods: {
    ...mapActions({
      valetWaterRecharge: "ZD_ValetWaterRecharge",
    }),
    handleClose() {
      this.dialogVisible = false;
    },
    limitOneDecimal(){
      // 正则核心规则：只保留数字、最多一个小数点、小数点后最多1位
      this.rechargePower = this.rechargePower
        .replace(/[^\d.]/g, '') // 1. 过滤掉所有非数字和非小数点的字符
        .replace(/^\./g, '') // 2. 禁止首位输入小数点
        .replace(/\.{2,}/g, '.') // 3. 只保留第一个小数点，禁止多个小数点
        .replace('.', '$#$').replace(/\./g, '').replace('$#$', '.') // 4. 再次兜底：确保只有一个小数点
        .replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3') // 5. 核心：小数点后只保留1位小数
    },
    limitTwoDecimal(){
      this.rechargeAmount = this.rechargeAmount
        .replace(/[^\d.]/g, '')
        .replace(/^\./g, '')
        .replace(/\.{2,}/g, '.')
        .replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        .replace(/^(\d+)\.(\d{2}).*$/, '$1.$2')
    },
    onClickPrint() {
      // 创建打印窗口
      const printWindow = window.open('', '_blank');

      // 构建打印内容
      const printContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8" />
          <title>Payment list</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 30px auto;
              width: 100%;
              max-width: 800px;
              line-height: 1.4;
              font-size: 16px;
              color: #000;
            }
            .header {
              text-align: center;
              padding-bottom: 0px;
              margin-bottom: 0px;
              font-size: 45px;
              font-weight: bold;
            }
            .content {
              margin: 0 auto;
              width: 100%;
              border-collapse: collapse;
              border: 1px solid #000;
              margin: 0 auto;
            }
            .content th,
            .content td {
              border: 1px solid #000;
              padding: 10px;
              text-align: left;
              vertical-align: top;
              font-size: 30px;

            }
            .content th {
              background-color: #f9f9f9;
              font-size: 30px;
            }
            .content tr:nth-child(even) {
              background-color: #f1f1f1;
            }
            .footer {
              margin-top: 40px;
              text-align: center;
              font-size: 14px;
              color: #666;
              font-weight: bold;
            }
            @media print {
              body {
                margin: 0;
                font-size: 18px;
              }
              .header {
                font-size: 28px;
              }
              .content {
                font-size: 16px;
              }
              .footer {
                font-size: 16px;
              }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <h2>${ this.$t("lang.充值回执单") }</h2>
          </div>

          <table class="content">
            <tr>
              <th>${ this.$t("lang.订单编号") }</th>
              <td style="word-wrap: break-word;word-break: break-all;white-space: normal;">
                 ${this.receiptData.orderNo || '--'}
               </td>
            </tr>
            <tr>
              <th>${ this.$t("lang.客户名称") }</th>
              <td>${this.deviceForm.deviceName || '--'}</td>
            </tr>
            <tr>
              <th>${ this.$t("lang.联系电话") }</th>
              <td>${this.deviceForm.phone || '--'}</td>
            </tr>
            <tr>
              <th>${ this.$t("lang.资产号") }</th>
              <td>${this.receiptData.tagNo || '--'}</td>
            </tr>
            <tr>
              <th>${ this.$t("lang.充值水量") }</th>
              <td>${this.fix(this.rechargePower)} m³</td>
            </tr>
            <tr>
              <th>${ this.$t("lang.充值金额") }</th>
              <td>${this.fix(this.rechargeAmount)} ${ this.monetary }</td>
            </tr>
            <tr>
              <th>${ this.$t("lang.水价") }</th>
              <td>${this.fix(this.receiptData.price) } ${ this.monetary }/m³</td>
            </tr>
            <tr>
              <th>${ this.$t("lang.充值Token") }</th>
              <td>${this.receiptData.token || '--'}</td>
            </tr>
            <tr>
              <th>${ this.$t("lang.支付时间") }</th>
              <td>${this.receiptData.createTime || '--'}</td>
            </tr>
          </table>

          <div class="footer">
            ********${new Date().toLocaleString()}********
          </div>
        </body>
        </html>
      `;

      // 写入内容并打印
      printWindow.document.write(printContent);
      printWindow.document.close();

      // 延迟执行打印，确保内容完全加载
      printWindow.onload = function() {
        printWindow.print();
        printWindow.close();
      };
    },
    rechargeChange(){
      if(this.rechargeValue){
        this.rechargeAmount = "0.00"
        this.rechargePower = ""
      }else{
        this.rechargePower = "0.0"
        this.rechargeAmount = ""
      }
    },
    showDialog(data) {
      if(data.rechargeType === 2){
        this.rechargeType =  2
        this.receiptData.orderNo = data.orderNo
        this.receiptData.tagNo = data.tagNo
        this.rechargePower = data.remain
        this.rechargeAmount = data.priceValue
        this.receiptData.price = data.price
        this.receiptData.token = data.token
        this.receiptData.createTime = data.createTime
      }else{
        this.rechargeType =  1
        this.rechargeChange();
      }
      this.password = "";
      this.dialogVisible = true;
      this.deviceForm = { ...data };
      this.deviceForm.priceValue = data.price || data.priceValue;
      if (
        this.deviceForm.remainTon !== "" &&
        this.deviceForm.remainTon !== undefined &&
        this.deviceForm.remainTon !== null
      ) {
        this.deviceForm.remainKwh = this.deviceForm.remainTon;
      }
      this.monetary = localStorage.getItem("monetary");
    },
    async onClickConfirmRecharge() {
      if (this.isnull(this.rechargePower))
        return this.$message.warning(this.$t("lang.请输入充值水量"));
      if (this.isPwd && this.isnull(this.password))
        return this.$message.warning(this.$t("lang.请输入二级密码"));
      let params = {
        value: {
          ton: this.rechargePower * 10,
          amount: this.rechargeAmount * 100,
          kwhMode: this.rechargeValue,
          pointId: this.deviceForm.pointId,
        },
      };
      if (this.isPwd) params.value.securityPwd = this.password;
      try {
        this.loading = true;
        let res = await this.valetWaterRecharge(params);
        if (res.success !== 1) return;
        this.dialogVisible = false;
        this.receiptData = res.value;
        this.$message({
          type: "success",
          message: this.$t("lang.充值成功"),
        });
        setTimeout(() => {
          this.receiptData.price = this.deviceForm.priceValue
          this.rechargeType = 2;
          this.dialogVisible = true;
        }, 200);
        this.$parent.onClickQuery();
      } catch {
      } finally {
        this.loading = false;
      }
    },
    onClickCopy() {
      let input = document.createElement("input");
      input.value = this.receiptData.token;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message({
        message: this.$t("lang.复制成功"),
        type: "success",
      });
    },
  },
};
</script>

<style scoped lang='less'>
.el-input {
  width: 300px;
}
/deep/.el-form-item__label {
  width: 155px;
}
/deep/.el-dialog__body {
  color: #333;
}
/deep/.el-input__inner{
  width: 300px;
}
.space-occupying {
  padding: 0 80px 10px;
  position: relative;
  height: 420px;
}

.printingPaper {
  position: absolute;
  top: 25px;
  width: 297px;
  height: 388px;
}

.returnReceiptCon {
  position: absolute;
  z-index: 999;
  top: 25px;
  width: 297px;
  height: 100%;
  padding: 0 30px;
  box-sizing: border-box;

  h2 {
    text-align: center;
    font-size: 15px;
    margin-top: 32px;
  }

  .dividingLine {
    border-bottom: 1px dashed #707070;
    margin: 15px auto;
  }
  .en_content {
    font-size: 12px;
    .con_title div {
      width: 125px !important;
      color: #999;
    }
    .con_text div {
      width: 130px !important;
      margin-left: -20px;
      text-align: right;
    }
  }
  .content {
    display: flex;

    .con_title {
      margin-right: 10px;

      div {
        width: 80px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
      }
    }

    .con_text {
      div {
        width: 140px;
        margin-bottom: 10px;
        word-break: break-all;
      }
    }

    .multipleLin {
      height: 48px;
      line-height: 2;
      i {
        cursor: pointer;
        color: #409eff;
        margin-left: 5px;
      }
    }
  }
}
</style>
